module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAICAYAAADN5B7xAAAAiklEQVQoU5WQPQpCMRCEZ5MUFvIeKt4tCRg7T5ZA2M7CRrC2sfE+IfsIaCOJ6Jaz8+3PEDqVUtporQOAGcDZWvt826gHNC3GOBljgojsAFycc4+mD4HWZOZ1KSUQ0V5Ert77O+WcT6MtTReRFYDty3P7H/g2vXvSCGDmudZ6+OnpFisRHZVS02esCw6FP224YpW5AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/go.png
// module id = VtVb
// module chunks = 1